import { tv } from "../../variants/tv.js";
const scrimVariants = tv({
    base: 'relative',
    variants: {
        padding: {
            2: 'p-2',
            3: 'p-3',
            4: 'p-4'
        },
        isTop: {
            true: "scrim-linear-gradient-to-bottom pb-14"
        },
        isBottom: {
            true: "scrim-linear-gradient-to-top pt-14"
        },
        isFull: {
            true: '[background:rgba(0,0,0,0.6)]'
        },
        overhang: {
            16: ''
        }
    },
    compoundVariants: [
        {
            isBottom: true,
            padding: 2,
            overhang: 16,
            class: 'pb-[4.5rem]'
        },
        {
            isBottom: true,
            padding: 3,
            overhang: 16,
            class: 'pb-[4.75rem]'
        },
        {
            isBottom: true,
            padding: 4,
            overhang: 16,
            class: 'pb-20'
        },
        {
            isTop: true,
            padding: 2,
            overhang: 16,
            class: 'pt-[4.5rem]'
        },
        {
            isTop: true,
            padding: 3,
            overhang: 16,
            class: 'pt-[4.75rem]'
        },
        {
            isTop: true,
            padding: 4,
            overhang: 16,
            class: 'pt-20'
        }
    ]
});
export { scrimVariants };
